import { AnimatePresence } from "framer-motion";
import { ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX, ZIndex } from "./constants";
import { AddIcon } from "../../../assets/icons";
import { Button } from "@altimateai/lego";
import { createPortal } from "react-dom";
import { MouseEvent } from "react";

interface Props {
  pos: { x: number; y: number; element: HTMLElement };
  onAddComment: (e: MouseEvent) => void;
}
const HighlightAnchor = ({ pos, onAddComment }: Props) => {
  return createPortal(
    <AnimatePresence>
      {pos && (
        <Button
          onClick={onAddComment}
          id={`${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}-highlight`}
          style={{
            position: "absolute",
            top: pos.y,
            left: pos.x,
            // right: "15px",
            zIndex: ZIndex + 5,
            cursor: "pointer",
            background: "#007AFF",
            width: 26,
            height: 26,
            borderRadius: "100%",
            boxShadow: "none",
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "13px",
            fontWeight: "bold",
            color: "#fff",
            padding: 0,
          }}
        >
          <AddIcon />
        </Button>
      )}
    </AnimatePresence>,
    pos.element.parentElement!,
  );
};

export default HighlightAnchor;
